import { ArrowRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
const projects = [{
  id: 1,
  title: "Residential Landscape Transformation",
  location: "Nepean, ON",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/nepean_residential_landscape_before_after.png",
  link: "/AboutPage"
}, {
  id: 2,
  title: "Commercial Hardscape Renovation",
  location: "Barrhaven, Nepean",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/barrhaven_commercial_paving_upgrade.png",
  link: "/AboutPage"
}, {
  id: 3,
  title: "Custom Backyard Oasis Build",
  location: "Manotick, Nepean",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/manotick_backyard_oasis_construction.png",
  link: "/AboutPage"
}];
export default function BeforeAfterGallery() {
  return <section data-section-id="238512" id="before-after-gallery" className="bg-background text-foreground py-24 px-4 md:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <h2 className="font-default text-4xl font-bold tracking-tight uppercase md:text-5xl lg:text-6xl text-primary">
              Our Recent Work
            </h2>
            <div className="mt-6 h-1 w-24 bg-secondary"></div>
          </div>
          <Link to="/AboutPage" className="group inline-flex items-center gap-2 font-default text-sm font-bold tracking-wider uppercase transition-colors hover:text-secondary">
            View Full Portfolio
            <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {projects.map((project, i) => <Card key={project.id} data-index={i} className="group relative h-[450px] overflow-hidden rounded-lg border border-border bg-muted p-0 lg:h-[550px] shadow-md">
              <img src={project.image} alt={`${project.title} in ${project.location}`} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/30 to-transparent opacity-70 transition-opacity duration-500 group-hover:opacity-0" />

              {}
              <div className="absolute inset-0 flex translate-y-full flex-col justify-end bg-primary/95 p-8 text-primary-foreground transition-transform duration-500 ease-in-out group-hover:translate-y-0">
                <h3 className="font-default text-2xl font-bold leading-tight tracking-tight uppercase lg:text-3xl">
                  {project.title}
                </h3>
                
                <div className="mt-4 mb-8 flex items-center gap-2 font-mono text-sm font-medium opacity-90">
                  <MapPin className="size-4 text-secondary" />
                  <span>{project.location}</span>
                </div>
                
                <Link to={project.link} className="inline-flex w-fit items-center gap-2 border-b-2 border-secondary pb-1 font-default text-sm font-bold tracking-wider uppercase transition-opacity hover:opacity-70">
                  Project Details
                  <ArrowRight className="size-4" />
                </Link>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}